import React, { useEffect, useState } from 'react';
import WorkingHours from 'components/working-hours';
import useNewShopContext from 'contexts/create-shop.context';

const CreateShopOpeningTime = () => {
  const { createShopForm, setCreateShopForm } = useNewShopContext();
  const { brand_working_hours } = createShopForm;
  const [workingHours, setWorkingHours] = useState(brand_working_hours);
  useEffect(() => {
    const updatedBrandWorkingHours = brand_working_hours?.map((brandHour: any) => {
      const matchingWorkHour = workingHours.find(
        (workHour: any) => workHour.name === brandHour.name
      );

      if (matchingWorkHour) {
        return {
          ...brandHour,
          opening_time: matchingWorkHour.opening_time,
          closing_time: matchingWorkHour.closing_time,
          active: matchingWorkHour.active
        };
      }

      return brandHour;
    });

    setCreateShopForm({
      ...createShopForm,
      brand_working_hours: updatedBrandWorkingHours
    });
  }, [workingHours]);

  return <WorkingHours data={workingHours} setData={setWorkingHours} />;
};

export default CreateShopOpeningTime;
